const coolingStageTableFields = vm => ([
  {
    key: 'name',
    label: '',
    thClass: 'cooling-stages-form__stage-name',
  },
  {
    key: 'stage0',
    label: vm.$t('asset-information.cooling-stages.stage-number', { number: 0 }),
    thClass: 'cooling-stages-form__stage',
  },
  {
    key: 'stage1',
    label: vm.$t('asset-information.cooling-stages.stage-number', { number: 1 }),
    thClass: 'cooling-stages-form__stage',
  },
  {
    key: 'stage2',
    label: vm.$t('asset-information.cooling-stages.stage-number', { number: 2 }),
    thClass: 'cooling-stages-form__stage',
  },
  {
    key: 'stage3',
    label: vm.$t('asset-information.cooling-stages.stage-number', { number: 3 }),
    thClass: 'cooling-stages-form__stage',
  },
  {
    key: 'stage4',
    label: vm.$t('asset-information.cooling-stages.stage-number', { number: 4 }),
    thClass: 'cooling-stages-form__stage',
  },
]);

export default coolingStageTableFields;
